import { NodeSpec } from 'prosemirror-model';

import { BaseExtension } from '@lyearn/lygo-core';

import { WebBookmarkLayout } from '../../types';
import { NODE_NAME } from './consts';
import plugins from './plugins';

export default class WebBookmark extends BaseExtension {
  get schema(): NodeSpec {
    return {
      attrs: {
        url: {
          default: null,
        },
        title: {
          default: null,
        },
        desc: {
          default: null,
        },
        img: {
          default: null,
        },
        coverImg: {
          default: null,
        },
        layout: {
          default: WebBookmarkLayout.Small,
        },
      },
      group: 'block',
      isAtom: true,
      parseDOM: [
        {
          tag: 'div.lygo-web-bookmark',
        },
      ],
      toDOM: (node) => {
        let href = node?.attrs?.url;
        return href
          ? [
              'div',
              { class: 'flex justify-center mt-16 lygo-web-bookmark' },
              ['a', { ...node.attrs }],
            ]
          : ['div'];
      },
    };
  }

  get name(): string {
    return NODE_NAME;
  }

  plugins = plugins;
}
